import { render, staticRenderFns } from "./ViewFolders.vue?vue&type=template&id=1cb518e3&"
import script from "./ViewFolders.vue?vue&type=script&lang=ts&"
export * from "./ViewFolders.vue?vue&type=script&lang=ts&"
import style0 from "./ViewFolders.vue?vue&type=style&index=0&id=1cb518e3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports